//arr  数据
//hours 推移时间   正数为往后推。负数为向前推
function overTimeToArr (data, hours) {
  let arr = JSON.parse(JSON.stringify(data));
  for (let i = 0; i < arr.length; i++) {
    let stTime = new Date(arr[i].time)
    let time = new Date(arr[i].time);
    time.setHours(time.getHours() + hours);
    arr[i].time = formatDate(stTime, "yyyy/MM/dd") + " " + formatDate(time, "hh:mm:ss")
    arr[i].value = parseFloat(arr[i].value.toFixed(2))
  }

  //按时间重新排序
  var arr2 = JSON.parse(JSON.stringify(arr));
  arr2.sort(function (a, b) {
    return a.time > b.time ? 1 : -1;
  });
  return arr2;
}

function clcaDemandMax (arr) {
  if (arr.length == 0) {
    return null
  }
  let result = [];

  result = arr[0]
  for (let i = 1; i < arr.length; i++) {
    for (let j = 0; j < arr[i].length; j++) {
      let has = false
      for (let k = 0; k < result.length; k++) {
        if (arr[i][j].time === result[k].time) {
          result[k].value = parseFloat(result[k].value.toFixed(2)) + parseFloat(arr[i][j].value.toFixed(2));
          has = true;
        }
      }

      if (!has) {
        result.push(arr[i][j])
      }
    }
  }
  //取出最大值
  result = result.sort(function (a, b) {
    return b.value - a.value;
  })
  var max = "-", maxDate = "-";
  if (result.length > 0) {
    max = result[0].value;
    //取出最大值对应时间
    maxDate = result[0].time
  }
  result.sort(function (a, b) {
    return a.time > b.time ? 1 : -1;
  });
  return { max: max, time: maxDate, data: result }
}

//判断值是否存在函数
function isBlank (val) {
  if (val == null || val == "") {
    return true;
  }
}



function formatDate (date, fmt) {
  date = date || new Date();
  fmt = fmt || "yyyy/MM/dd hh:mm:ss";
  if (Object.prototype.toString.call(date).slice(8, -1) !== "Date") {
    date = new Date(date);
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
}
function padLeftZero (str) {
  return ("00" + str).substr(str.length);
}
export default { overTimeToArr, clcaDemandMax }